import React from 'react';
import { Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { dateFormatter, infoFormatter, infoFormatterIntl } from '../../../utils/formatters';
import RecipientView from './RecipientView';
import { APPLICATION_STATUS, USER_TYPE } from '../../../configs';

export default function SZLTViewData({ currentSZLT, formMeta }) {
  const { legal_entity_type = 0 } = currentSZLT;

  return (
    <>
      <Row className="row-cols-2">
        {infoFormatterIntl('registry.number', currentSZLT.number, formMeta, 'number')}
        {infoFormatterIntl('created_at', dateFormatter(currentSZLT.created_at), formMeta, 'created_at')}
      </Row>
      {[USER_TYPE.LEGAL, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(legal_entity_type)
        ? (
          <Row className="row-cols-2">
            {infoFormatterIntl('decision', currentSZLT.decision, formMeta, 'decision')}
            {infoFormatterIntl('decision_date', dateFormatter(currentSZLT.decision_date), formMeta, 'decision_date')}
          </Row>
        ) : null}
      <Row className="row-cols-2">
        {infoFormatterIntl('effective_date', dateFormatter(currentSZLT.effective_date), formMeta, 'effective_date')}
        {infoFormatterIntl('expiration_date', dateFormatter(currentSZLT.expiration_date), formMeta, 'expiration_date')}
      </Row>
      {
          [APPLICATION_STATUS.SUSPENDED, APPLICATION_STATUS.CHECKING].includes(currentSZLT.status) ? (
            <Row className="row-cols-3">
              {infoFormatter('Основание', currentSZLT.rejection_reason_messages?.[0]?.name || '')}
              {infoFormatter('Дополнительное основание', currentSZLT?.rejection_reason_messages?.[0]?.additional_message || '')}
              {infoFormatter('Комментарий', currentSZLT.rejection_reason_messages?.[0]?.message || '')}
            </Row>
          ) : null
        }
      <RecipientView current={currentSZLT} isSZLT formMeta={formMeta} />
      <div className="hr-row" />
      <div className="f4">Дополнительная информация</div>
      <Row className="row-cols-3">
        {infoFormatterIntl('office_phone', currentSZLT.office_phone, formMeta, 'office_phone')}
        {infoFormatterIntl('office_email', currentSZLT.office_email, formMeta, 'office_email')}
        {infoFormatterIntl('web_site', currentSZLT.web_site, formMeta, 'web_site')}
      </Row>
      <Row className="row-cols-2">
        {infoFormatterIntl('commercial_name', currentSZLT.commercial_name, formMeta, 'commercial_name')}
        {infoFormatterIntl('logo_files', currentSZLT.logo_files, formMeta, 'logo_files')}
      </Row>
      <Row className="row-cols-1">
        {infoFormatterIntl('order_receiving_methods', currentSZLT.order_receiving_methods, formMeta, 'order_receiving_methods')}
      </Row>
      <Row className="row-cols-1">
        {infoFormatterIntl('office_address', currentSZLT.office_address, formMeta, 'office_address')}
      </Row>
      <Row className="row-cols-1">
        {infoFormatterIntl('software_names', currentSZLT.software_names, formMeta, 'software_names')}
      </Row>
      <Row className="row-cols-2">
        {infoFormatterIntl('database_address', currentSZLT.database_address, formMeta, 'database_address')}
        {infoFormatterIntl('server_address', currentSZLT.server_address, formMeta, 'server_address')}
      </Row>
    </>
  );
}
